import React from 'react';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

const PublishButton = ({
  selectedCandidates,
  jobId,
  publishedCandidates,
  candidatePublishApiStatus,
  setSelectedCandidates,
  setSelectedActiveCandidateCount,
  candidateListType,
  bulkActivitySelection,
  actionName,
  candidateContext,
  bulkCandidateRecommend,
  featureToggleList,
}) => {
  const {
    FavouriteBucket: { IsEnabled: isFavouriteBucketEnabled },
  } = featureToggleList;

  const handlePublishCandidate = () => {
    setSelectedCandidates({ candidateType: 'Recommended', selectedCandidates: [] });
    setSelectedActiveCandidateCount({ candidateType: 'Recommended', selectedActiveCandidateCount: 0 });
    if (isFavouriteBucketEnabled) {
      const recommendedInfoUpdateCommand = selectedCandidates.map(candidate => {
        let _candidate;
        if (candidateListType === 'aryarecommended') _candidate = { CandidateId: candidate };
        else _candidate = _.cloneDeep(candidate);
        _.set(_candidate, ['RecommendedInfo', 'Status'], actionName);
        return _candidate;
      });
      const bulkPayload = {
        jobId,
        recommendedInfoUpdateCommand,
        candidateListType,
        bulkActivitySelection,
        actionName,
        candidateContext,
      };
      bulkCandidateRecommend(bulkPayload);
    } else publishedCandidates({ selectedCandidates, jobId });
  };
  const isPublishCandidateButtonDisabled = selectedCandidates.length;
  return (
    <Button
      type="primary"
      loading={candidatePublishApiStatus === 'INPROGRESS'}
      onClick={handlePublishCandidate}
      disabled={!isPublishCandidateButtonDisabled}
    >
      <FormattedMessage {...message.publishCandidateLabel} />
    </Button>
  );
};

export default PublishButton;
